export default () => ({
  showModal: false,
  info: false
})



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/history/index/components/schedule/resources/data.js